import http from "../http";
import Service from "../../Service";

export default class PermissionService extends Service {
    list(params = {}) {
        return http.get("v2/commons/permissions", {
            headers: this.getHeaders(),
            params,
        });
    }

    my() {
        return http.get("v2/commons/permissions/my", {
            headers: this.getHeaders(),
        });
    }
}
